import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type FsAnalyticsUserSharedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FsAnalyticsUserSharedQuery = { analyticsEnvironment: string, preparedUserId: string | null, currentUser: { __typename: 'User', id: string, email: string, currentUserRoleType: string } | null };


export const FsAnalyticsUserSharedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FsAnalyticsUser_Shared_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserRoleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsEnvironment"}},{"kind":"Field","name":{"kind":"Name","value":"preparedUserId"}}]}}]} as unknown as DocumentNode;
export type FsAnalyticsUserSharedQueryQueryResult = Apollo.QueryResult<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>;

export function useFsAnalyticsUserSharedQuery(
  baseOptions?: Apollo.QueryHookOptions<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>
) {
  return Apollo.useQuery<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>(
    FsAnalyticsUserSharedQueryDocument,
    baseOptions
  );
}

export function useFsAnalyticsUserSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>) {
  return Apollo.useLazyQuery<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>(
    FsAnalyticsUserSharedQueryDocument,
    baseOptions
  );
}

export function useFsAnalyticsUserSharedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>) {
  return Apollo.useSuspenseQuery<FsAnalyticsUserSharedQuery, FsAnalyticsUserSharedQueryVariables>(
    FsAnalyticsUserSharedQueryDocument,
    baseOptions
  );
}
